module.exports = __webpack_public_path__ + "mainlogo.png?de2b629697ce254d424bba2a92819276";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mainlogo.png
// module id = 205
// module chunks = 0